<div class="notification-container">
  <!-- 🔥 HEADER / PREVIEW -->
  <div class="notification-header">
    <div class="image" *ngIf="notifDetails.image">
      <img [src]="imageBaseUrl + notifDetails.image" alt="notification" />
    </div>

    <div class="content">
      <h2 class="title">
        {{ notifDetails.title || "No Title" }}
      </h2>

      <p class="description">
        {{ notifDetails.description || "No description available" }}
      </p>

      <div class="badges">
        <nz-tag [nzColor]="notifDetails.status ? 'green' : 'red'">
          {{ notifDetails.status ? "Active" : "Inactive" }}
        </nz-tag>

        <nz-tag [nzColor]="notifDetails.type === 'user' ? 'purple' : 'blue'">
          {{ notifDetails.type | titlecase }}
        </nz-tag>

        <nz-tag [nzColor]="notifDetails.sendNow ? 'green' : 'orange'">
          {{ notifDetails.sendNow ? "Instant" : "Scheduled" }}
        </nz-tag>

        <nz-tag
          *ngIf="notifDetails.approveStatus"
          [nzColor]="
            notifDetails.approveStatus === 'approved'
              ? 'green'
              : notifDetails.approveStatus === 'pending'
                ? 'lime'
                : 'volcano'
          "
        >
          {{ notifDetails.approveStatus | titlecase }}
        </nz-tag>
      </div>
    </div>
  </div>

  <!-- 🔥 DETAILS GRID -->
  <div class="info-grid">
    <!-- MODULE -->
    <div class="info-card" *ngIf="notifDetails.targetModule">
      <span nz-icon nzType="database"></span>
      <div>
        <label>Module</label>
        <p>{{ notifDetails.targetModule | titlecase }}</p>
      </div>
    </div>

    <!-- AUDIENCE -->
    <div class="info-card" *ngIf="notifDetails.targetAudience">
      <span nz-icon nzType="team"></span>
      <div>
        <label>Audience</label>
        <p>{{ notifDetails.targetAudience | titlecase }}</p>
      </div>
    </div>

    <!-- SCHEDULE -->
    <div class="info-card">
      <span nz-icon nzType="calendar"></span>
      <div>
        <label>Schedule</label>
        <p>
          {{ notifDetails.scheduleDate | date: "dd MMM yyyy, HH:mm" }}
        </p>
      </div>
    </div>

    <!-- END DATE -->
    <div class="info-card" *ngIf="notifDetails.endDate">
      <span nz-icon nzType="clock-circle"></span>
      <div>
        <label>End Date</label>
        <p>
          {{ notifDetails.endDate | date: "dd MMM yyyy, HH:mm" }}
        </p>
      </div>
    </div>

    <!-- REPEAT -->
    <div class="info-card">
      <span nz-icon nzType="redo"></span>
      <div>
        <label>Repeat</label>
        <p>
          {{
            notifDetails.repeatDaysType !== "none"
              ? (notifDetails.repeatDaysType | titlecase)
              : "No repeat"
          }}
        </p>
      </div>
    </div>

    <!-- CUSTOM REPEAT -->
    <div class="info-card" *ngIf="notifDetails.repeatDaysType === 'custom'">
      <span nz-icon nzType="sync"></span>
      <div>
        <label>Repeat Every</label>
        <p>{{ notifDetails.repeatDays }} day(s)</p>
      </div>
    </div>

    <!-- REFERENCE -->
    <div class="info-card full" *ngIf="notifDetails.referenceName">
      <span nz-icon nzType="link"></span>
      <div>
        <label>Reference</label>
        <p class="strong">{{ notifDetails.referenceName }}</p>
      </div>
    </div>

    <!-- CREATED BY -->
    <div class="info-card full">
      <span nz-icon nzType="user"></span>
      <div>
        <label>Created By</label>
        <p>{{ notifDetails.createdBy?.name || "Admin" }}</p>
      </div>
    </div>

    <!-- REJECTION REASON -->
    <div class="info-card full" *ngIf="notifDetails.rejectionReason">
      <span nz-icon nzType="close-circle"></span>
      <div>
        <label>Rejection Reason</label>
        <p>{{ notifDetails.rejectionReason }}</p>
      </div>
    </div>
  </div>

  <!-- 🔥 ACTION -->
  <div class="action-bar">
    <button nz-button nzType="primary" (click)="updateNotification()">
      <span nz-icon nzType="edit"></span>
      Update Notification
    </button>
  </div>
</div>
